module.exports = __webpack_public_path__ + "img/appAsset-brand--axteroid-icon-test.2fa47482.svg";